import React, { useEffect } from 'react';
import {
  Grid,
  Typography,
  FormControlLabel,
  FormHelperText,
} from '@material-ui/core';
import { Field, useFormikContext, ErrorMessage } from 'formik';
import { TextField, RadioGroup } from 'formik-material-ui';

import CustomRadio from 'components/CustomRadio';
import { IExpandedMailingRule } from 'interfaces/MailingRule';
import { IMailingRuleSubformProps } from '../../interfaces';

import { KeyboardDatePicker } from 'formik-material-ui-pickers';

const Form: React.FC<IMailingRuleSubformProps> = ({
  isEditable,
}: IMailingRuleSubformProps) => {
  const {
    values,
    touched,
    errors,
    setFieldValue,
  } = useFormikContext<IExpandedMailingRule>();

  useEffect(() => {
    if (values.permanenceType === 'permanenceInDays') {
      setFieldValue('permanenceUntilDate', new Date());
    } else if (values.permanenceType === 'permanenceUntilDate') {
      setFieldValue('permanenceInDays', 0);
    }
  }, [values.permanenceType, setFieldValue]);

  const isPermanenceTypeErrored =
    !!touched.permanenceType && !!errors.permanenceType;

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="flex-start"
    >
      <Grid item xs={12}>
        <Typography variant="h6">Tempo de Permanência na EPS</Typography>
      </Grid>
      <Grid
        data-cy="temporal-parameters-form__radio-buttons--permanence-type"
        item
        xs={12}
      >
        <Field component={RadioGroup} name="permanenceType">
          <FormHelperText error>
            <ErrorMessage name="permanenceType" />
          </FormHelperText>

          <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item>
              <FormControlLabel
                value="permanenceInDays"
                control={
                  <CustomRadio
                    error={
                      isPermanenceTypeErrored ||
                      (!!touched.permanenceInDays && !!errors.permanenceInDays)
                    }
                  />
                }
                label="Duração em dias"
                disabled={!isEditable}
              />
            </Grid>
            {values.permanenceType === 'permanenceInDays' && (
              <Grid
                data-cy="temporal-parameters-form__input--permanence-in-days"
                item
                xs={3}
              >
                <Field
                  component={TextField}
                  name="permanenceInDays"
                  disabled={!isEditable}
                />
              </Grid>
            )}
          </Grid>
          <Grid item container alignItems="center">
            <FormControlLabel
              value="permanenceUntilDate"
              control={
                <CustomRadio
                  error={
                    isPermanenceTypeErrored ||
                    (!!touched.permanenceUntilDate &&
                      !!errors.permanenceUntilDate)
                  }
                />
              }
              label="Até a seguinte data"
              disabled={!isEditable}
            />
            {values.permanenceType === 'permanenceUntilDate' && (
              <Field
                data-cy="temporal-parameters-form__input--permanence-until-date"
                component={KeyboardDatePicker}
                name="permanenceUntilDate"
                disabled={!isEditable}
                disablePast
                disableToolbar
                format="dd/MM/yyyy"
                variant="inline"
                invalidDateMessage="Por favor, insira uma data válida"
              />
            )}
          </Grid>
        </Field>
      </Grid>

      {/* <Grid item xs={12}>
        <Typography variant="h6">
          Prazo para inicio do pagamento de comissão / remuneração variável por
          atingimento de meta
        </Typography>
      </Grid>

      <Grid
        item
        xs={9}
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
        className={classes.containerInputBetweenTexts}
      >
        <Grid item xs={4} sm={2}>
          <Typography>Pagamento a partir de </Typography>
        </Grid>
        <Grid
          data-cy="temporal-parameters-form__input--payment-remuneration-days"
          item
          xs={3}
          sm={2}
          md={2}
        >
          <Field
            component={TextField}
            type="number"
            name="paymentRemunerationDays"
            disabled={!isEditable}
          />
        </Grid>
        <Grid item xs={3}>
          <Typography> dias após o envio da remessa</Typography>
        </Grid>
      </Grid> */}
    </Grid>
  );
};

export default Form;
